import { Box, useMediaQuery } from '@mui/material'
import Header from './Header'
import MenuPC from '../components/MenuPC'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export default function UserLayout(props) {
	const { currentUser } = useSelector((state) => state.currentUser)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [height, setHeight] = useState(window.innerHeight)
	const [isMenuCollapsed, setIsMenuCollapsed] = useState(false)

	useEffect(() => {
		window.addEventListener('resize', () => {
			setHeight(window.innerHeight)
		})
	}, [height])

	return (
		<Box>
			<Header />
			{!mediaMd && (
				<Box
					maxHeight={height}
					overflow='auto'
					sx={{
						position: 'fixed',
						left: 0,
						right: 0,
						bottom: 0,
						top: 56,
						background: 'white',
					}}>
					{props.children}
				</Box>
			)}
			{mediaMd && (
				<Box display='flex'>
					<MenuPC 
						isMenuCollapsed={isMenuCollapsed}
						setIsMenuCollapsed={setIsMenuCollapsed}
					/>
					<Box
						maxHeight={height}
						overflow='auto'
						sx={{
							position: 'fixed',
							left: currentUser.isLoggedIn && !isMenuCollapsed ? 300 : 0,
							right: 0,
							bottom: 0,
							top: 64,
							background: 'white',
							transition: 'left 0.3s ease-in-out',
						}}>
						{props.children}
					</Box>
				</Box>
			)}
		</Box>
	)
}
